<sw-modal
    :title="modalTitle"
    @modal-close="onCancel"
>
    <sw-text-field
        v-model="entity.term"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelTerm')"
    ></sw-text-field>

    <sw-textarea-field
        v-model="entity.synonyms"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelSynonyms')"
        :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.placeholderSynonyms')"
    ></sw-textarea-field>

    <sw-single-select
        v-model:value="entity.boostLevel"
        :options="boostOptions"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelBoost')"
        :help-text="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.helpBoost')"
    />

    <sw-field
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelScope')"
        class="topdata-es-synonym-scope-group"
    >
        <sw-button-group split-button="false">
            <sw-button
                :variant="entity.scope === 'PRODUCT' ? 'primary' : 'ghost'"
                @click="entity.scope = 'PRODUCT'"
            >
                {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeProduct') }}
            </sw-button>
            <sw-button
                :variant="entity.scope === 'CATEGORY' ? 'primary' : 'ghost'"
                @click="entity.scope = 'CATEGORY'"
            >
                {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeCategory') }}
            </sw-button>
            <sw-button
                :variant="entity.scope === 'GLOBAL' ? 'primary' : 'ghost'"
                @click="entity.scope = 'GLOBAL'"
            >
                {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeBoth') }}
            </sw-button>
        </sw-button-group>
    </sw-field>

    <sw-single-select
        v-if="isNew"
        v-model:value="entity.languageId"
        :options="languageOptions"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelLanguage')"
        :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.placeholderLanguage')"
        :show-clearable="true"
    />
    <sw-text-field
        v-else
        :value="getLanguageLabel(entity.languageId)"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.labelLanguage')"
        disabled
    />

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>
